<template>
  <div class="import-orders-container">
    <h2>Importazione Ordini</h2>

    <div class="form-section">
      <label for="start">Inizio:</label>
      <input type="date" v-model="startDate" id="start" />

      <label for="end">Fine:</label>
      <input type="date" v-model="endDate" id="end" />

      <button @click="importOrders" :disabled="loading">
        {{ loading ? 'Importazione in corso...' : 'Importa Ordini' }}
      </button>
    </div>

    <div class="log-section">
      <h3>Log Importazione</h3>
      <pre class="log-output">{{ logs }}</pre>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { initializeApp, getApps } from 'firebase/app';
import { getFirestore, doc, setDoc, getDoc } from 'firebase/firestore';
import { buildTopSkuFields } from '@/lib/topSku';

const firebaseConfig = {
  /* 🔐 Inserisci le tue credenziali Firebase se necessario */
};

if (getApps().length === 0) {
  initializeApp(firebaseConfig);
}
const db = getFirestore();

const startDate = ref('');
const endDate = ref('');
const logs = ref('');
const loading = ref(false);

const importOrders = async () => {
  if (!startDate.value || !endDate.value) {
    logs.value = '❌ Inserisci entrambe le date';
    return;
  }

  loading.value = true;
  logs.value = '';

  try {
    const response = await fetch(
      `https://www.fusco.fit/export-orders.php?start_date=${startDate.value}&end_date=${endDate.value}`
    );
    const orders = await response.json();

    if (!Array.isArray(orders)) {
      logs.value = `❌ Errore: ${JSON.stringify(orders)}`;
      loading.value = false;
      return;
    }

    for (const order of orders) {
      const docId = `export_${order.orderId}`;
      const docRef = doc(db, 'orders', docId);
      const docSnap = await getDoc(docRef);
      const topSkuFields = buildTopSkuFields(order, { fallbackToNow: false });

      await setDoc(docRef, {
        orderId: order.orderId,
        orderDate: order.orderDate,
        status: order.status,
        totalPrice: order.totalPrice,
        paymentMethod: order.paymentMethod,
        products: order.products,
        userEmail: order.userEmail || null,
        importedAt: new Date().toISOString(),
        ...topSkuFields
      }, { merge: true });

      logs.value += docSnap.exists()
        ? `🔁 Ordine ${docId} aggiornato\n`
        : `✅ Ordine ${docId} importato\n`;
    }

    logs.value += `\n🚀 Importazione completata: ${orders.length} ordini`;
  } catch (err) {
    logs.value = `❌ Errore: ${err.message}`;
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.import-orders-container {
  padding: 20px;
  max-width: 600px;
  margin: auto;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

input[type='date'],
button {
  padding: 8px;
  font-size: 1rem;
}

button {
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}

button:disabled {
  background-color: #999;
  cursor: not-allowed;
}

.log-section {
  margin-top: 20px;
  background: #f5f5f5;
  border-radius: 6px;
  padding: 12px;
}

.log-output {
  font-family: monospace;
  white-space: pre-wrap;
  max-height: 250px;
  overflow-y: auto;
}
</style>
